import { render, staticRenderFns } from "./FbLogin.vue?vue&type=template&id=616d56d4&scoped=true"
import script from "./FbLogin.vue?vue&type=script&lang=js"
export * from "./FbLogin.vue?vue&type=script&lang=js"
import style0 from "./FbLogin.vue?vue&type=style&index=0&id=616d56d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616d56d4",
  null
  
)

export default component.exports